import { createContext } from 'react'
import { TFormsContext } from './types'

export const FormsContext = createContext<TFormsContext>({

})